import React from "react";
import { isArray, upperFirst } from "lodash";
import {
  Grid,
  GridColumn,
  Header,
  Label,
  Segment,
  Table,
} from "semantic-ui-react";

import { BatteryIdDropdown, ExportDataAsCsv } from "../UtilComponents";
import moment from "moment";

const BatteryEventsTable = ({ user_group, swap, data, filename }) => {
  return (
    <GridColumn style={{ color: "black" }}>
      <Segment>
        <Grid>
          {user_group === "overall_admin" &&
            swap.events &&
            // colorMapping &&
            swap.events &&
            isArray(swap.events) && (
              <GridColumn width="16">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Header style={{ color: "#444" }}>
                    {swap.events.length} Battery events
                  </Header>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <ExportDataAsCsv {...{ data, filename }} />
                  </div>
                </div>

                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell className="left-header">
                        Module
                      </Table.HeaderCell>
                      <Table.HeaderCell className="inner-header">
                        Slot
                      </Table.HeaderCell>

                      <Table.HeaderCell className="inner-header">
                        Timestamp
                      </Table.HeaderCell>

                      {swap.is_cmcu && (
                        <Table.HeaderCell className="inner-header">
                          Battery id
                        </Table.HeaderCell>
                      )}

                      {swap.is_cmcu && (
                        <Table.HeaderCell className="inner-header">
                          Soc
                        </Table.HeaderCell>
                      )}
                      <Table.HeaderCell className="right-header">
                        Action
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {swap &&
                      swap.swap_events &&
                      isArray(swap.events) &&
                      swap.swap_events.map((item) => (
                        <>
                          {
                            <Table.Row>
                              <Table.Cell>{item.module_number}</Table.Cell>
                              <Table.Cell>{item.slot_number}</Table.Cell>

                              <Table.Cell>
                                {moment(item.swap_event_created_at).format(
                                  "DD-MM-YYYY HH:mm:ss"
                                )}
                              </Table.Cell>
                              {swap.is_cmcu && (
                                <Table.Cell textAlign="left">
                                  {swap.initial_serial_numbers.includes(
                                    item.battery_id
                                  ) ? (
                                    <>
                                      <BatteryIdDropdown
                                        isInitialBatteryId={swap.initial_serial_numbers.includes(
                                          item.battery_id
                                        )}
                                        text={item.battery_id}
                                        battery_id={item.battery_id}
                                        battery_type={upperFirst(
                                          swap.battery_type
                                        )}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <BatteryIdDropdown
                                        isInitialBatteryId={swap.initial_serial_numbers.includes(
                                          item.battery_id
                                        )}
                                        battery_id={item.battery_id}
                                        battery_type={upperFirst(
                                          swap.battery_type
                                        )}
                                      />
                                    </>
                                  )}
                                </Table.Cell>
                              )}

                              {swap.is_cmcu && (
                                <Table.Cell>
                                  {item.state_of_charge
                                    ? item.state_of_charge + "%"
                                    : "-"}
                                </Table.Cell>
                              )}

                              <Table.Cell>
                                <Label
                                  circular
                                  content={item.swap_action}
                                  color={
                                    item.swap_action === "IN" ? "green" : "red"
                                  }
                                  style={{ width: 40 }}
                                />
                              </Table.Cell>
                            </Table.Row>
                          }
                        </>
                      ))}
                  </Table.Body>
                </Table>
                {swap?.swap_events?.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#444",
                      width: "100%",
                    }}
                  >
                    no data available
                  </div>
                ) : null}
              </GridColumn>
            )}
        </Grid>
      </Segment>
    </GridColumn>
  );
};

export default BatteryEventsTable;
